import {
  AppleLogo,
  GoogleCalendarLogo,
  OutlookLogo,
  YahooLogo,
} from '../../../../../../assets/images';
import {
  generateGoogleCalendarEvent,
  generateIcsCalendarFile,
  generateYahooCalendarEvent,
} from './CalendarListFunctions';
import { CalendarDef } from './calendarDef';

export const availableCalendars: CalendarDef[] = [
  {
    displayName: 'Google Calendar',
    logo: GoogleCalendarLogo,
    actionFunc: generateGoogleCalendarEvent,
  },
  {
    displayName: 'Apple Calendar',
    logo: AppleLogo,
    actionFunc: generateIcsCalendarFile,
  },
  {
    displayName: 'Yahoo Calendar',
    logo: YahooLogo,
    actionFunc: generateYahooCalendarEvent,
  },
  {
    displayName: 'Outlook Calendar',
    logo: OutlookLogo,
    actionFunc: generateIcsCalendarFile,
  },
];
